<mat-chip class="provider-chip">
  <img *ngIf="provider.logo_base64" [src]="provider.logo_base64"/>
  <span class="label">
    {{ provider.name }}
  </span>
</mat-chip>
